import { executePost } from "../ServiceMethods";
import { removeUserCredentials, userId } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

const id = userId();

export const dashboardApi = async (data, cb) => {
  try {
    const dashboardData = await executePost("/businessUser/dashboard", data);
    const DashboardData = dashboardData.data ? dashboardData.data : {};
    return DashboardData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
